export default {
	main: '#2F89FC',
	secondary: '#FBB13C',
	tertiary: '#575366',
	grey: '#565465',
	actions: {
		success: '#00b339',
		danger: '#ff2525'
	}
}
  